import React, { useEffect } from "react";
import { Routes, Route, Outlet, Link, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Logo from "./Components/Logo";
import Home from "./Components/Home";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import Payments from "./Components/Payments";
import Investment from "./Components/Investment";
import Insurance from "./Components/Insurance";
import Transfer from "./Components/Transfer";
import Loans from "./Components/Loans";
import Banking from "./Components/Bank";
import About from "./Components/About";
import PricingPage from "./Components/Pricing";
import Features from "./Components/Features";
import Help from "./Components/Help";
import EmiCalculator from "./Components/EmiCalculator";
import GadgetLoan from "./Components/Cibill";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import TermsConditions from "./Components/TermsConditions";
import Products from "./Components/products";
import Moneybro from "./Components/Moneybro"; 
import PaisaDaily from "./Components/PaisaDaily"; 
import Careers from "./Components/Careers";
import ApplyPage from "./Components/ApplyPage";

import ApplicationForm from "./Components/ApplicationForm";

export const triggerApplyModal = (role = '') => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('open-apply-modal', { detail: role }));
  }
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function Layout() {
  const location = useLocation();
  const [showApplyModal, setShowApplyModal] = React.useState(false);
  const [applyRole, setApplyRole] = React.useState('');

  const openApplyModal = (role = '') => {
    setApplyRole(role);
    setShowApplyModal(true);
  };

  useEffect(() => {
    const handleOpenModalEvent = (e) => {
      openApplyModal(e.detail || '');
    };
    window.addEventListener('open-apply-modal', handleOpenModalEvent);
    return () => window.removeEventListener('open-apply-modal', handleOpenModalEvent);
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar onOpenForm={openApplyModal} />
      <main>
        <Outlet context={{ openApplyModal }} />
      </main>
      {showApplyModal && (
        <ApplicationForm
          initialRole={applyRole}
          onClose={() => setShowApplyModal(false)}
        />
      )}
      {location.pathname !== "/moneybro" && location.pathname !== "/paisadaily" && location.pathname !== "/apply" && location.pathname !== "/application-form" && (
      <footer className="fintech-footer">
        <div className="footer-bento">
          <div className="fintech-footer-brand">
            <div className="fintech-footer-logo" style={{ marginBottom: '1.25rem' }}>
              <Logo height={40} light={true} />
            </div>
            <p className="fintech-footer-desc">
              88-E, 2nd Floor, Near Punjab and Sind Bank, Jindal Chowk, Hisar, Haryana - 125001
            </p>
          </div>

          <div className="fintech-footer-links">
            <h3 className="fintech-footer-title">Company</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/features">Features</Link></li>
            </ul>
          </div>

          <div className="fintech-footer-links">
            <h3 className="fintech-footer-title">Legal</h3>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="fintech-footer-links">
            <h3 className="fintech-footer-title">Connect</h3>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><a href="mailto:kubersetu@gmail.com">kubersetu@gmail.com</a></li>
              <li><a href="tel:+919660236005">+91-9660236005</a></li>
            </ul>
          </div>

          <div className="fintech-footer-bottom">
            <p>&copy; {new Date().getFullYear()} Kubersetu Infotech Private Limited. All rights reserved.</p>
          </div>
        </div>
      </footer>
      )}
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/investment" element={<Investment />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/transfer" element={<Transfer />} />
        <Route path="/loans" element={<Loans />} />
        <Route path="/banking" element={<Banking />} />
        <Route path="/about" element={<About />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/features" element={<Features />} />
        <Route path="/help" element={<Help />} />
        <Route path="/GadgetLoan" element={<GadgetLoan />} />
        <Route path="/EmiCalculator" element={<EmiCalculator />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/products" element={<Products />} />
        <Route path="/moneybro" element={<Moneybro />} />
        <Route path="/paisadaily" element={<PaisaDaily />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/application-form" element={<ApplyPage />} />
      </Route>
    </Routes>
  );
}

export default App;
